import React from "react";

import Btn from "./BackBtn.styles";

const BackBtn = () => {
  return (
    <div>
      <div onClick={() => window.history.back()}>
        <Btn>بازگشت</Btn>
      </div>
    </div>
  );
};

export default BackBtn;
